export function getQueryParams(qs) {
    let episodicDetails ={isEpisodic : false, vId : null};
    let paramString = qs?.split('?').length > 0 ? qs?.split('?')[1] : null;
    if (paramString) {
      let params_arr = paramString.split('&') || [paramString];
  
      for (let i = 0; i < params_arr.length; i++) {
        let pair = params_arr[i]?.split('=');
        if (pair.includes('vid') || pair.includes('vId')) episodicDetails = {isEpisodic : true, vId : pair[1]};
      }
    }
    return episodicDetails;
  }

 export const formulateAllPlanIdsArray = (data) => {
    let planGroupList = JSON.parse(localStorage.getItem("planGroupList"))
        let monetisationPlans = data?.plans?.filter((content) => content?.type === "SVOD" || content?.monetizationModel === "SVOD")
        let monetisationPlansIds = monetisationPlans?.map((plan) => plan?.planIds || plan?.id)
        let monetisationGroupIds = monetisationPlans?.map((plan) => plan?.planGroupIds)
        monetisationGroupIds?.forEach((groupId) => {
            if(groupId) {
                monetisationPlansIds.push(planGroupList[groupId])
            }
        })
        let ids = monetisationPlansIds ? monetisationPlansIds.filter(item => item !== undefined && item !== null) : []
        return ids
  }